import React from 'react';
import { CustomHtmlElement as CustomHtmlType } from '../../types/element.types';

interface CustomHtmlElementProps {
  element: CustomHtmlType;
}

/**
 * Custom HTML Element Renderer
 * Renders custom HTML content
 */
const CustomHtmlElement: React.FC<CustomHtmlElementProps> = ({ element }) => {
  return (
    <div
      className="custom-html-element"
      style={element.styles as React.CSSProperties}
      dangerouslySetInnerHTML={{ __html: element.content || '' }}
    />
  );
};

export default CustomHtmlElement;

